export default __webpack_public_path__ + "static/media/IkonNounCoins.d13c6424.svg";